module.exports = "pegasus_template/assets/rectangle-twitter.png";